import { render, staticRenderFns } from "./LoadingPage.vue?vue&type=template&id=23617002&scoped=true&"
import script from "./LoadingPage.vue?vue&type=script&lang=ts&"
export * from "./LoadingPage.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingPage.vue?vue&type=style&index=0&id=23617002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23617002",
  null
  
)

export default component.exports